import { combineReducers } from 'redux';
import vignets from './vignets';
import gallery from './gallery';
import pages from './pages';
import playlist from './playlist';
import user from "./user";
import overview from "./overview";
import upload from "./upload";

const app = combineReducers({
    vignets,
    gallery,
    pages,
    playlist,
    user,
    overview,
    upload
});
export default app;




// WEBPACK FOOTER //
// ./src/reducers/index.js